<template>
    <div class="lds-ripple">
        <div/>
        <div/>
    </div>
</template>

<script>
    import '@scss/components/loading-indicator.scss';

    export default {}
</script>
